import React, { useState, useEffect,useRef } from "react";
import { Button, Form, Card, Row, Col,Dropdown , Modal} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const GrnMaster = () => {
  const tableHeaders = ["#", "GRN Number", "GRN Date", "Received By", "Status"];
  const [poItems, setPoItems] = useState([]);
  const [productData, setProductData] = useState([]);
  const navigate = useNavigate();

  const [grnData, setGrnData] = useState([]);
  const [poData, setPoData] = useState([]);
  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("user_name");
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showStatusCard, setShowStatusCard] = useState(false);
  const [selectedGrn, setSelectedGrn] = useState(null);
  const [grnItems, setGrnItems] = useState([]);

  const [formData, setFormData] = useState({
    id: null,
    po_id: "",
    grn_number: "",
    grn_date: "",
    received_by: userId,
    remarks: "",
    status: 1,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    await fetchGrnData();
    await fetchPoData();
    await fetchProductData();
  };

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

      setProductData(allProducts);
    } catch (err) {
      toast.error("Failed to fetch product data");
    }
  };

  const getProductName = (id) => {
    const p = productData.find((item) => item.id === id);
    return p ? p.product_name : "-";
  };

  const fetchGrnData = async () => {
    const warehouse_id = localStorage.getItem("warehouse_id");
    try {
      const res = await axios.get(`${var_api}sa_veemart_grn/get-warehouse/${warehouse_id}`);
      
      let data = Array.isArray(res.data) ? res.data : res.data.data || [];
      data = data.sort((a, b) => b.id - a.id);

      setGrnData(data);
    } catch {
      toast.error("Failed to fetch GRN data");
    }
  };

  const fetchPoData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_po/get-warehouse/${localStorage.getItem("warehouse_id")}`);
      setPoData(Array.isArray(res.data) ? res.data : res.data.data || []);
    } catch {
      toast.error("Failed to fetch PO data");
    }
  };

  // ✅ CHANGE 1: handlePoChange - Use parseFloat for decimal qty
  const handlePoChange = async (e) => {
    const poId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      po_id: poId,
    }));

    if (!poId) {
      setPoItems([]);
      return;
    }

    try {
      const res = await axios.get(`${var_api}sa_veemart_po_details/getByPoId/${poId}`);

      if (Array.isArray(res.data)) {
        setPoItems(
          res.data.map((it) => ({
            ...it,
            required_qty: parseFloat(it.qty) || 0,
            received_qty: 0.000,
            balance_qty: parseFloat(it.qty) || 0,
          }))
        );
      } else if (Array.isArray(res.data.data)) {
        setPoItems(
          res.data.data.map((it) => ({
            ...it,
            required_qty: parseFloat(it.qty) || 0,
            received_qty: 0.000,
            balance_qty: parseFloat(it.qty) || 0,
          }))
        );
      } else {
        setPoItems([]);
      }
    } catch {
      toast.error("Failed to load PO Items");
    }
  };

  const [showMailCard, setShowMailCard] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const today = new Date().toISOString().slice(0, 10);

  const handleAddClick = () => {
    setFormData({
      id: null,
      po_id: "",
      grn_number: "",
      grn_date: today,
      received_by: userId,
      remarks: "",
      status: 1,
    });
    setErrors({});
    setIsEditMode(false);
    setShowForm(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowForm(true);
  };

  useEffect(() => {
    const storedPoId = localStorage.getItem("sa_veemart_po_id");

    if (storedPoId) {
      setShowForm(true);
      setIsEditMode(false);

      setFormData((prev) => ({
        ...prev,
        po_id: storedPoId,
        grn_date: today,
        received_by: userId,
      }));

      preloadPOItems(storedPoId);
      localStorage.removeItem("sa_veemart_po_id");
    }
  }, []);

  // ✅ CHANGE 2: preloadPOItems - Use parseFloat for decimal qty
  const preloadPOItems = async (poId) => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_po_details/getByPoId/${poId}`);

      const items = Array.isArray(res.data)
        ? res.data
        : res.data.data || [];

      setPoItems(
        items.map((it) => ({
          ...it,
          required_qty: parseFloat(it.qty) || 0,
          received_qty: 0.000,
          balance_qty: parseFloat(it.qty) || 0,
        }))
      );
    } catch (err) {
      toast.error("Failed to load PO items");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // ✅ CHANGE 3: handleItemChange - Use parseFloat for calculations
  const handleItemChange = (index, value) => {
    const updated = [...poItems];
    const rq = parseFloat(updated[index].required_qty) || 0;
    const rc = parseFloat(value) || 0;

    updated[index].received_qty = value;
    updated[index].balance_qty = (rq - rc).toFixed(3);

    setPoItems(updated);
  };

  const handleMarkAsReceived = async () => {
    try {
      const payload = { status: 2 };

      const res = await axios.put(
        `${var_api}sa_veemart_grn/update/${selectedGrn.id}`,
        payload
      );

      toast.success("GRN marked as Received!");
      setSelectedGrn((prev) => ({ ...prev, status: 2 }));
      fetchGrnData();
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  // ✅ CHANGE 4: handleSubmit - Use parseFloat and toFixed for payload
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.po_id) newErrors.po_id = "PO is required";
    if (!formData.grn_date) newErrors.grn_date = "GRN date is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct highlighted fields");
      return;
    }

    const payload = {
      ...formData,
      warehouse_id: 1,
      details: poItems.map((item) => ({
        product_id: item.product_id,
        required_qty: parseFloat(item.required_qty).toFixed(3),
        received_qty: parseFloat(item.received_qty).toFixed(3),
        balance_qty: parseFloat(item.balance_qty).toFixed(3),
        unit_price: parseFloat(item.unit_price).toFixed(2),
      })),
    };

    try {
      setLoading(true);

      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(
          `${var_api}sa_veemart_grn/update/${formData.id}`,
          payload
        );
      } else {
        res = await axios.post(`${var_api}sa_veemart_grn/post`, payload);
      }

      toast.success(res?.data?.message || "Saved successfully!");
      setShowForm(false);
      await fetchGrnData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  const fetchGrnDetailItems = async (grnId) => {
    try {
      const res = await axios.get(
        `${var_api}sa_veemart_grn_details/getByGrnId/${grnId}`
      );

      const details = Array.isArray(res.data)
        ? res.data
        : res.data.data || [];

      setGrnItems(details);
    } catch (error) {
      toast.error("Failed to fetch GRN details");
    }
  };

  const poStatusRef = useRef(null);

  const handleDownloadPDF = async () => {
    if (!poStatusRef.current) {
      toast.error("Right section not found!");
      return;
    }

    const input = poStatusRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("GRN_Details.pdf");
  };

  const handlePrint = () => {
    if (!poStatusRef.current) {
      toast.error("Right section not found!");
      return;
    }

    const printContent = poStatusRef.current.innerHTML;
    const win = window.open("", "", "height=700,width=900");
    win.document.write("<html><head><title>Print</title></head><body>");
    win.document.write(printContent);
    win.document.write("</body></html>");
    win.document.close();
    win.print();
  };

  const handleSendMailClick = () => {
    setShowForm(false);
    setShowStatusCard(false);
    setShowMailCard(true);
  };

  const filteredData = grnData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      {/* FORM CARD */}
      {showForm && (
        <Card className="mb-4 shadow-sm border-0 rounded-4">
          <Card.Header>
            <strong className="fs-5 text-dark">
              {isEditMode ? "Edit GRN" : "Add New GRN"}
            </strong>
          </Card.Header>

          <Card.Body className="p-4">
            <Form onSubmit={handleSubmit}>
              <Row className="g-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-dark">
                      PO Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="po_id"
                      value={formData.po_id}
                      onChange={handlePoChange}
                      className="rounded-3 py-2 text-dark"
                    >
                      <option value="">Select PO Number</option>
                      {poData.map((po) => (
                        <option key={po.id} value={po.id}>
                          {po.po_number}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.po_id && (
                      <small className="text-danger">{errors.po_id}</small>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-dark">
                      GRN Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="grn_date"
                      value={formData.grn_date}
                      onChange={handleInputChange}
                      className="rounded-3 py-2 text-dark"
                    />
                    {errors.grn_date && (
                      <small className="text-danger">{errors.grn_date}</small>
                    )}
                  </Form.Group>
                </Col>

                {/* ✅ CHANGE 5: PO Items table - Display with 3 decimals */}
                <Col md={12}>
                  <Card className="shadow-sm border-0 rounded-4 mt-3">
                    <Card.Header>
                      <h4>PO Items</h4>
                    </Card.Header>

                    <Card.Body className="p-0">
                      <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                          <thead>
                            <tr className="text-dark">
                              <th>#</th>
                              <th>Product</th>
                              <th>Required Qty (kg)</th>
                              <th>Received Qty (kg)</th>
                              <th>Balance Qty (kg)</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                            </tr>
                          </thead>

                          <tbody>
                            {poItems.length === 0 ? (
                              <tr>
                                <td colSpan="7" className="text-center text-muted py-4">
                                  No items found. Select a PO Number.
                                </td>
                              </tr>
                            ) : (
                              poItems.map((item, index) => (
                                <tr key={index} className="text-dark">
                                  <td className="fw-semibold">{index + 1}</td>
                                  <td>{getProductName(item.product_id)}</td>
                                  <td>{parseFloat(item.required_qty).toFixed(3)}</td>

                                  <td>
                                    <input
                                      type="number"
                                      className="form-control rounded-3 text-dark"
                                      value={item.received_qty}
                                      min="0"
                                      step="0.001"
                                      placeholder="0.000"
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "" || /^\d*\.?\d{0,3}$/.test(val)) {
                                          handleItemChange(index, val);
                                        }
                                      }}
                                    />
                                  </td>

                                  <td>{parseFloat(item.balance_qty).toFixed(3)}</td>
                                  <td>₹{parseFloat(item.unit_price).toFixed(2)}</td>
                                  <td>
                                    ₹{(parseFloat(item.required_qty) * parseFloat(item.unit_price)).toFixed(2)}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold text-dark">Remarks</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="remarks"
                      value={formData.remarks}
                      onChange={handleInputChange}
                      className="rounded-3 text-dark"
                      placeholder="Enter remarks"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-3 mt-4">
                <Button variant="secondary" type="submit" className="px-4 py-2 rounded-3">
                  {loading
                    ? isEditMode
                      ? "Updating..."
                      : "Saving..."
                    : isEditMode
                    ? "Update GRN"
                    : "Save as Draft"}
                </Button>

                <Button
                  variant="danger"
                  className="px-4 py-2 rounded-3"
                  onClick={() => setShowCancelConfirm(true)}
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      )}

      <Modal show={showCancelConfirm} onHide={() => setShowCancelConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">
            <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
            Leave this page?
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>If you leave, your unsaved changes will be discarded.</p>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end">
          <Button
            variant="primary"
            className="px-4"
            style={{ borderRadius: "6px", backgroundColor: "#007bff", border: "none" }}
            onClick={() => setShowCancelConfirm(false)}
          >
            Stay Here
          </Button>

          <Button
            variant="light"
            className="px-4 text-dark border"
            onClick={() => {
              setShowCancelConfirm(false);
              setShowForm(false);
            }}
          >
            Leave & Discard Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ✅ CHANGE 6: Mail Card - Display qty with 3 decimals */}
      {showMailCard && selectedGrn && (
        <Card className="shadow-lg p-4 mt-4">
          <h4 className="mb-4 fw-bold">Send GRN Mail</h4>

          <Form
            onSubmit={async (e) => {
              e.preventDefault();

              try {
                const itemsHtml = grnItems
                  .map(
                    (it, idx) => `
                      <tr>
                        <td>${idx + 1}</td>
                        <td>${getProductName(it.product_id)}</td>
                        <td>${parseFloat(it.received_qty).toFixed(3)} kg</td>
                        <td>₹${parseFloat(it.unit_price).toFixed(2)}</td>
                        <td>₹${(parseFloat(it.received_qty) * parseFloat(it.unit_price)).toFixed(2)}</td>
                      </tr>
                    `
                  )
                  .join("");

                const emailBody = `
                  <div style="font-family: Arial; line-height: 1.6; color: #333;">
                    <p>Dear Recipient,</p>
                    <p>Please find below the GRN details:</p>
                    <p><b>GRN Number:</b> ${selectedGrn.grn_number}</p>
                    <p><b>GRN Date:</b> ${selectedGrn.grn_date}</p>
                    <p><b>Received By:</b> ${userName}</p>
                    <h4>Items:</h4>
                    <table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
                      <thead>
                        <tr style="background:#f8f9fa;">
                          <th>#</th>
                          <th>Product</th>
                          <th>Qty (kg)</th>
                          <th>Unit Price</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${itemsHtml}
                      </tbody>
                    </table>
                    <p><b>Remarks:</b> ${selectedGrn.remarks || "-"}</p>
                    <p>Thanks,<br/>${userName}</p>
                  </div>
                `;

                const emailPayload = {
                  to: formData.email,
                  subject: `GRN Details - ${selectedGrn.grn_number}`,
                  html: emailBody,
                };

                const res = await axios.post(
                  `${var_api}sa_veemart_admin/send-email`,
                  emailPayload
                );

                toast.success(res?.data?.message || "Mail sent successfully!");
                setShowMailCard(false);
              } catch (err) {
                toast.error(err?.response?.data?.message || "Failed to send mail");
              }
            }}
          >
            <Row className="g-4">
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>From</Form.Label>
                  <Form.Control
                    type="email"
                    value={localStorage.getItem("warehouse_email") || ""}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>To</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Recipient Email"
                    value={formData.email || ""}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={`GRN Details - ${selectedGrn.grn_number}`}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Preview</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    readOnly
                    value={`
Dear Recipient,

Please find below the GRN details:

GRN Number: ${selectedGrn.grn_number}
GRN Date: ${selectedGrn.grn_date}
Received By: ${userName}

Items:
${grnItems
  .map(
    (it, idx) =>
      `${idx + 1}. ${getProductName(it.product_id)} - Qty: ${parseFloat(it.received_qty).toFixed(3)} kg, Unit Price: ₹${parseFloat(it.unit_price).toFixed(2)}, Total: ₹${(
        parseFloat(it.received_qty) * parseFloat(it.unit_price)
      ).toFixed(2)}`
  )
  .join("\n")}

Remarks: ${selectedGrn.remarks || "-"}

Thanks,
${userName}
                    `}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-3 mt-4">
              <Button variant="secondary" type="submit" className="px-4 py-2 rounded-3">
                Send Mail
              </Button>
              <Button
                variant="light"
                className="px-4 py-2 rounded-3"
                onClick={() => setShowMailCard(false)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </Card>
      )}

      {/* TABLE SECTION */}
      {!showForm && !showStatusCard && !showMailCard && (
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-end mb-3 gap-2">
              <input
                type="text"
                className="form-control w-auto"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <Button variant="secondary" onClick={handleAddClick}>
                Add
              </Button>
            </div>

            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    {tableHeaders.map((h, i) => (
                      <th key={i}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center text-muted">
                        No data found
                      </td>
                    </tr>
                  ) : (
                    paginatedData.map((item, idx) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                        <td>{item.grn_number}</td>
                        <td>{formatDate(item.grn_date)}</td>
                        <td>{userName || "-"}</td>
                        <td>
                          <span
                            className={`badge ${
                              item.status === 1 ? "bg-warning text-white" : "bg-success"
                            }`}
                            style={{
                              cursor: "pointer",
                              fontSize: "0.85rem",
                              padding: "6px 10px",
                              borderRadius: "8px",
                              textTransform: "uppercase",
                              fontWeight: 600,
                            }}
                            onClick={() => {
                              localStorage.setItem("sa_veemart_grn_id", item.id);
                              fetchGrnDetailItems(item.id);
                              setSelectedGrn(item);
                              setShowStatusCard(true);
                              setShowForm(false);
                            }}
                          >
                            {item.status === 1 ? "Draft" : "Received"}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              <div className="d-flex justify-content-end mt-3">
                {[...Array(totalPages)].map((_, idx) => (
                  <Button
                    key={idx}
                    variant={currentPage === idx + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(idx + 1)}
                    className="me-1"
                  >
                    {idx + 1}
                  </Button>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* ✅ CHANGE 7: Status Card - Display qty with 3 decimals */}
      {showStatusCard && selectedGrn && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            minHeight: "100vh",
            background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)",
            padding: "20px",
          }}
        >
          <Card
            className="shadow-lg border-0"
            style={{ width: "100%", maxWidth: "1400px", borderRadius: "16px", overflow: "hidden" }}
          >
            <Card.Body className="p-0">
              <Row className="g-0">
                <Col md={3} style={{ backgroundColor: "#f8f9fa", borderRight: "1px solid #dee2e6" }}>
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h6 className="mb-0 fw-bold">All GRNs</h6>
                    </div>

                    <Card className="mb-2" style={{ backgroundColor: "#fff", border: "2px solid #007bff", borderRadius: "8px" }}>
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <h6 className="mb-1 fw-bold">{selectedGrn.grn_number}</h6>
                            <p>
                              <strong>GRN Date:</strong>{" "}
                              {selectedGrn.grn_date
                                ? new Date(selectedGrn.grn_date).toLocaleDateString("en-GB")
                                : "-"}
                            </p>
                          </div>
                          <div className="text-end">
                            <h6 className="mb-0">{selectedGrn.status === 1 ? "Draft" : "Received"}</h6>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </Col>

                <Col md={9}>
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                      <div className="d-flex align-items-center gap-3">
                        <Button variant="outline-secondary" size="sm" onClick={() => setShowStatusCard(false)}>
                          <i className="fas fa-arrow-left me-2"></i>Back
                        </Button>
                        <h4 className="mb-0 fw-bold">{selectedGrn.grn_number}</h4>
                      </div>
                      {selectedGrn.status === 1 && (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={handleMarkAsReceived}
                        >
                          <i className="fas fa-check me-2"></i>Mark as Received
                        </Button>
                      )}

                      <div className="d-flex gap-2">
                        <Button variant="outline-primary" size="sm" onClick={handleSendMailClick}>
                          <i className="fas fa-envelope me-2"></i>Send Mail
                        </Button>

                        <Dropdown>
                          <Dropdown.Toggle variant="outline-secondary" size="sm">
                            <i className="fas fa-file-pdf me-2"></i>PDF / Print
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDownloadPDF}>Download PDF</Dropdown.Item>
                            <Dropdown.Item onClick={handlePrint}>Print</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>

                        <Button variant="outline-danger" size="sm" onClick={() => setShowStatusCard(false)}>
                          <i className="fas fa-times me-2"></i>Close
                        </Button>
                      </div>
                    </div>

                    <div
                      className="alert d-flex justify-content-between align-items-center mb-4"
                      style={{ backgroundColor: "#e7f3ff", border: "1px solid #b3d9ff", borderRadius: "8px" }}
                    >
                      <div>
                        <i className="fas fa-lightbulb me-2" style={{ color: "#ff1493" }}></i>
                        <strong style={{ color: "#ff1493" }}>WHAT'S NEXT?</strong>{" "}
                        <span>{selectedGrn.status === 1 ? "GRN is in Draft. Mark as Received to proceed." : "GRN has been received successfully!"}</span>
                      </div>
                    </div>

                    <div ref={poStatusRef} className="position-relative d-flex justify-content-center">
                      <Card
                        className="shadow border-0 position-relative"
                        style={{ width: "100%", maxWidth: "800px", borderRadius: "12px", backgroundColor: "#fff" }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: "20px",
                            left: "-30px",
                            backgroundColor: selectedGrn.status === 1 ? "#de610eff" : "#28a745",
                            color: "#fff",
                            transform: "rotate(-45deg)",
                            width: "150px",
                            textAlign: "center",
                            fontWeight: "600",
                            padding: "5px 0",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                            fontSize: "12px",
                          }}
                        >
                          {selectedGrn.status === 1 ? "DRAFT" : "RECEIVED"}
                        </div>

                        <Card.Body className="p-5">
                          <div className="text-center mb-5">
                            <h2 className="fw-bold" style={{ fontSize: "36px" }}>GRN SUMMARY</h2>
                            <h3 className="text-muted mb-2">GRN# {selectedGrn.grn_number}</h3>
                          </div>

                          <Row className="mb-5">
                            <Col md={6}>
                              <p>
                                <strong>GRN Date:</strong>{" "}
                                {selectedGrn.grn_date
                                  ? new Date(selectedGrn.grn_date).toLocaleDateString("en-GB")
                                  : "-"}
                              </p>
                            </Col>
                            <Col md={6} className="text-end">
                              <p><strong>Status:</strong> {selectedGrn.status === 1 ? "Draft" : "Received"}</p>
                            </Col>
                          </Row>

                          <div className="table-responsive mb-5">
                            <table className="table table-bordered">
                              <thead style={{ backgroundColor: "#d2e2f2ff", color: "#fff" }}>
                                <tr>
                                  <th>#</th>
                                  <th>Product</th>
                                  <th className="text-end">Qty (kg)</th>
                                  <th className="text-end">Unit Price</th>
                                  <th className="text-end">Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {grnItems.length === 0 ? (
                                  <tr>
                                    <td colSpan="5" className="text-center text-muted">
                                      No GRN items found.
                                    </td>
                                  </tr>
                                ) : (
                                  grnItems.map((it, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{getProductName(it.product_id)}</td>
                                      <td className="text-end">{parseFloat(it.received_qty).toFixed(3)} kg</td>
                                      <td className="text-end">₹{parseFloat(it.unit_price).toFixed(2)}</td>
                                      <td className="text-end">₹{(parseFloat(it.received_qty) * parseFloat(it.unit_price)).toFixed(2)}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default GrnMaster;